import { render, staticRenderFns } from "./MX20.vue?vue&type=template&id=db7c0c9e"
import script from "./MX20.vue?vue&type=script&lang=js"
export * from "./MX20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports